import {ready} from '~/core'
import addEvents from '~/utils/addEvents'

const INIT_PAGE_NUMBER = 1;

ready('money-burst-search', '.mb-search', (mbSearch) => {
    window.xxxyyy = mbSearch;
    const list = mbSearch.querySelector('.mb-search__results')
    const loadMore = document.querySelector('.mb-search__load-more')
    const searchButton = document.querySelector('.hero-filters__submit')
    const searchInput = document.querySelector('.hero-filters__search')
    const topics = [...document.querySelectorAll('#topics.hero-filters__multiselect input')]
    const categories = [...document.querySelectorAll(
        '#categories.hero-filters__multiselect ' +
        '.hero-filters__multiselect-item:not(.template) ' +
        'input'
    )]
    const categoryTemplate = mbSearch.querySelector('#categories.hero-filters__multiselect .template')
    const categoryList = mbSearch.querySelector('#categories.hero-filters__multiselect .hero-filters__multiselect-list')
    const allCategories = categories[0]

    const filterList = mbSearch.querySelector('.mb-search__filter-list')
    const filterTemplate = mbSearch.querySelector('.mb-search__filter-list-item.template')
    let clearFiltersButton = mbSearch.querySelector('.mb-search__filter-list-clear')
    const showingNumber = mbSearch.querySelector('.mb-search__results-count')

    const topicsLabel = document.querySelector(
        '#topics.hero-filters__multiselect .hero-filters__multiselect-label span[data-selectedLabel]',
    )

    const categoriesLabel = document.querySelector(
        '#categories.hero-filters__multiselect .hero-filters__multiselect-label span[data-selectedLabel]',
    )

    const endpoint = mbSearch.dataset.endpoint
    const initTotalResults = showingNumber.querySelector('.count-max').textContent
    const url = window.location.origin + window.location.pathname
    let page = INIT_PAGE_NUMBER
    let loading = false

    searchButton.href = window.location.search

    const urlParams = new URLSearchParams(window.location.search)
    const queryTopics = urlParams.get('topics')?.split(',') || []
    const queryCategories = urlParams.get('categories')?.split(',') || []
    const querySearch = urlParams.get('query')

    for (const topicInput of topics)
        topicInput.checked = queryTopics.includes(topicInput.value)

    for (const categoryInput of categories)
        categoryInput.checked = queryCategories.includes(categoryInput.value)

    if (queryTopics.length > 0) {
        const selectedLabeltopics = topicsLabel.dataset.selectedlabel
        const itemCountTopics = topicsLabel.querySelector('.label-count')
        itemCountTopics.textContent = `(${queryTopics.length} ${selectedLabeltopics})`
    }

    if (queryCategories.length > 0) {
        const selectedLabelCategories = categoriesLabel.dataset.selectedlabel
        const itemCountCategories = categoriesLabel.querySelector('.label-count')
        itemCountCategories.textContent = `(${queryCategories.length} ${selectedLabelCategories})`
    }
    else if(allCategories)
        allCategories.checked = true


    if (querySearch) {
        searchInput.value = querySearch
    }

    checkFilters()
    updateNumberResults(initTotalResults)

    history.replaceState({
        page,
        selectedTopics: urlParams.get('topics'),
        selectedCategories: urlParams.get('categories'),
        query: querySearch,
        data: list.innerHTML,
        hasMoreResults: !!loadMore,
        totalresults: initTotalResults,
    }, '', window.location.href);

    const getMorePosts = async (resetPage) => {
        if (loading) return;

        loading = true
        toggleLoadingClasses(true, resetPage)

        if (resetPage)
            page = INIT_PAGE_NUMBER - 1

        page++

        const selectedTopics = topics
            .filter((i) => i.checked)
            .map((i) => i.value)
            .join(',')
        const selectedCategories = categories
            .filter((i) => i.checked && i.value !== 'all-categories')
            .map((i) => i.value)
            .join(',')
        const query = searchInput.value

        const queryParams = `?page=${page}${selectedTopics ? `&topics=${selectedTopics}` : ''}${selectedCategories ? `&categories=${selectedCategories}` : ''}${query ? `&query=${query}` : ''
            }`;
        const fullEndpoint = `${endpoint.split('?')[0]}${queryParams}`

        const response = await fetch(`${fullEndpoint}`)

        if (response.ok) {
            const hasMoreResults = response.headers.get('hasmoreresults')
            const totalresults = response.headers.get('totalresults')
            const responseFilters = JSON.parse(response.headers.get('filter'));

            const data = await response.text()

            if (resetPage)
                list.innerHTML = data
            else
                list.insertAdjacentHTML('beforeend', data)

            if (hasMoreResults !== undefined)
                loadMore.style.display = hasMoreResults === 'false' ? 'none' : 'block'

            blue.init['video-modal']?.()

            const visibleQueryParams = queryParams.replace("page=" + page, '').replace("?&", "?")
            const newURL = `${url}${visibleQueryParams === "?" ? "" : visibleQueryParams}`
            history.pushState({
                page,
                selectedTopics,
                selectedCategories,
                query,
                data: list.innerHTML,
                hasMoreResults,
                totalresults,
            }, '', `${newURL}`);

            updateCategories(responseFilters.Categories)
            updateNumberResults(totalresults)

        }
        else {
            console.error('Error fetching search results', response)
            loading = false
            return;
        }

        checkFilters()
        toggleLoadingClasses(false)
        loading = false
    }

    window.onpopstate = function (event) {
        if (event.state) {
            page = event.state.page || INIT_PAGE_NUMBER

            for (const topicInput of topics)
                topicInput.checked = event.state.selectedTopics?.includes(topicInput.value)

            for (const categoryInput of categories)
                categoryInput.checked = event.state.selectedCategories?.includes(categoryInput.value)

            updateMultiselects()

            searchInput.value = event.state.query || ""

            if (event.state.hasMoreResults !== undefined)
                loadMore.style.display = event.state.hasMoreResults === 'false' ? 'none' : 'block'

            if (event.state.data)
                list.innerHTML = event.state.data

            updateNumberResults(event.state.totalresults)
        }
        else {
            window.onpopstate({ state: {} });
            getMorePosts(true)
        }

        checkFilters()
    }

    window.triggerSearch = () => getMorePosts(true);

    if (loadMore != null)
        addEvents(loadMore, 'click', e => getMorePosts())

    if (searchButton)
        addEvents(searchButton, 'click.prevent', _ => getMorePosts(true))

    if (searchInput)
        addEvents(searchInput, 'enter', _ => getMorePosts(true))



    // HELPER FUNCTIONS //
    function toggleLoadingClasses(force, loadingAnim) {
        loadMore.classList.toggle('is-loading', force)
        searchButton.classList.toggle('is-loading', force)

        const listIsLoading = list.classList.contains('is-loading')
        if (loadingAnim || listIsLoading)
            list.classList.toggle('is-loading', force)
    }

    function checkFilters() {
        const filterListLabel = filterList.querySelector('.mb-search__filter-list-label');
        const selectedTopics = topics.filter((i) => i.checked);
        const selectedCategories = categories.filter((i) => i.checked && i.value !== 'all-categories');
        const hasFilters = selectedTopics.length > 0 || selectedCategories.length > 0;
        const hasSearch = searchInput.value.length > 0;

        filterList.style.display = hasFilters || hasSearch ? 'flex' : 'none';
        filterListLabel.style.display = hasFilters ? 'block' : 'none';

        if (selectedTopics.length > 0 || selectedCategories.length > 0) {
            const label = filterListLabel.outerHTML;
            const clear = clearFiltersButton.cloneNode(true);
            filterList.innerHTML = label;

            [...selectedTopics, ...selectedCategories].forEach((i) => createFilterItem(i));

            clearFiltersButton = clear;
            if (clearFiltersButton)
                addEvents(clearFiltersButton, 'click', clearFilters);
            filterList.appendChild(clearFiltersButton);
        }
        else if (hasSearch) {
            if (clearFiltersButton)
                addEvents(clearFiltersButton, 'click', clearFilters);
        }
        else
            filterList.querySelectorAll('.mb-search__filter-list-item:not(.template)').forEach(i => i.remove());
    }

    function clearFilters() {
        searchInput.value = '';
        topics.forEach((i) => i.checked = false);
        categories.forEach((i) => i.checked = false);
        updateMultiselects();
        checkFilters();
        getMorePosts(true);
    }

    function clearFilter(e) {
        [...topics, ...categories].find((i) => i.id === e.target.dataset.id).checked = false;
        updateMultiselects();
        checkFilters();
        getMorePosts(true);
    }

    function updateMultiselects() {
        if (topics.length > 0)
            topics[0].dispatchEvent(new Event('change'));
        if (categories.length > 0)
            categories[0].dispatchEvent(new Event('change'));
    }

    function updateNumberResults(maxResults) {
        const count = showingNumber.querySelector('.count-showing');
        const max = showingNumber.querySelector('.count-max');
        const results = document.querySelectorAll('.mediaBlock').length;

        count.textContent = results;
        max.textContent = maxResults || "N/A";

        if (maxResults === "0" || results === 0 || max.textContent === "N/A")
            showingNumber.classList.add('no-results');
        else
            showingNumber.classList.remove('no-results');
    }

    function updateCategories(newCategories) {
        categories.forEach((category) => {
            if (category === allCategories) return;
            category.parentElement.classList.add('hidden');
        });

        newCategories.forEach((category) => {
            const matchingCategory = categories.find((cat) => {
                if (cat === allCategories) return false;
                return parseInt(cat.value) === parseInt(category.CategoryID)
            });

            if (matchingCategory)
                matchingCategory.parentElement.classList.remove('hidden');
            else
                createCategoryItem(category);
        })
    }

    function createFilterItem(input) {
        const item = filterTemplate.cloneNode(true);
        item.classList.remove('template');
        item.setAttribute('style', '');
        item.querySelector('span').textContent = input.parentElement.querySelector('label').textContent;
        item.dataset.id = input.id;
        item.addEventListener('click', clearFilter);
        filterList.appendChild(item);
    }

    function createCategoryItem(category) {
        const item = categoryTemplate.cloneNode(true);
        const input = item.querySelector('input');
        const label = item.querySelector('label');
        const id = `category_${category.CategoryID}`;
        const text = category.CategoryDisplayName;

        item.classList.remove('template');
        item.setAttribute('style', '');

        label.textContent = text;
        label.setAttribute('for', id)

        input.id = id;
        input.value = category.CategoryID;

        categories.push(input);
        categoryList.appendChild(item);
    }
})